import { Box,IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useSelector ,useDispatch} from "react-redux";
import { preparePopupGraphData } from "./quotaUtils";
import { setState } from "./quotaApprovalSlice";
import CloseIcon from '@mui/icons-material/Close'

export default function MultilineChart() {
	const dispatch=useDispatch();
	const state = useSelector((store) => store.quota);
	const { popupGraphData } = state;
	const [graphData, setGraphData] = useState({
		periods: [], 
		seriesData: [],
		colors: []
	});
   
   useEffect(() => {
      const data = preparePopupGraphData(popupGraphData);
      setGraphData({
         ...state,
         periods: data.periods,
         seriesData: data.seriesData,
		 colors : data.color
      });
   }, []);

	const options = {
		title: {
			text: `Data Sources`,
			align: "left",
		},
		tooltip: {
			y: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		xaxis: {
			categories: [...graphData.periods],
		},
		yaxis: {
			labels: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		stroke: {
			width: 2,
			curve: "smooth",
		},
		markers: {
			size: 5,
		},
		colors: graphData.colors,
	};
	const series = [...graphData.seriesData];
    
	function handleClose() {
		dispatch(setState("graphModalOpen", false));
		dispatch(setState("popupGraphData", null));
	 }

	return (
			<Box>
				<Box
				sx={{
				display: "flex",
				justifyContent: "flex-end",
				alignItems: "center",
				marginBottom: "16px",
				}}
     			 >
					<IconButton onClick={handleClose}>
					<CloseIcon />
					</IconButton>
      			</Box>
				<Chart
					options={options}
					series={series}
					type="line"
					height={500}
					width={780}
				/>
		</Box>

	);
}
